// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"C5-z","colorTextValue":"D5-z","swatches":"E5-z","collapseLink":"F5-z","isCollapsed":"G5-z","dropdown":"H5-z","disabled":"I5-z"};